/** Routes shown in the navbar, in registry order. */
export function navRoutes(registry) {
    return registry.filter((r) => !r.footerOnly);
}
/** Routes shown in the footer: every nav route, then the footerOnly (legal) ones. */
export function footerRoutes(registry) {
    return [...navRoutes(registry), ...registry.filter((r) => r.footerOnly)];
}
/**
 * Legacy `shell.nav` + `footer.links` mapped into a registry. Nav entries whose target is in
 * `drop` (the retired contact route) are removed; legal links become `footerOnly`.
 */
export function routeRegistryFromNav(nav, legal = [], opts = {}) {
    const drop = new Set(opts.drop ?? []);
    const out = [];
    for (const n of nav) {
        if (drop.has(n.to))
            continue;
        out.push({
            path: n.to,
            label: n.label,
            ...(n.end ? { end: true } : {}),
            ...(n.className ? { className: n.className } : {}),
        });
    }
    const seen = new Set(out.map((r) => r.path));
    for (const l of legal) {
        if (seen.has(l.to) || drop.has(l.to))
            continue;
        seen.add(l.to);
        out.push({ path: l.to, label: l.label, footerOnly: true });
    }
    return out;
}
//# sourceMappingURL=siteRoutes.js.map